// DS: i10.16
import React, { useId } from 'react';
import IconWrap, { Props } from '../../IconWrap';

const Wixel: React.FC<Props> = props => {
  const gradientAId = useId();
  const gradientBId = useId();
  return (
    <IconWrap {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path fill={`url(#${gradientAId})`} d="M1 1h16.16v16.16H1z" />
        <path
          fill={`url(#${gradientBId})`}
          d="M6.84 6.84H23V20.9a2.1 2.1 0 0 1-2.1 2.1H6.83V6.84Z"
        />
        <path fill="#5AD87B" d="M8.95 8.95h5.97v5.97H8.95z" />
        <defs>
          <linearGradient
            id={gradientAId}
            x1="9.08"
            x2="9.08"
            y1="1"
            y2="17.16"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#FEBA8A"></stop>
            <stop offset="1" stopColor="#FF90E6"></stop>
          </linearGradient>
          <linearGradient
            id={gradientBId}
            x1="14.92"
            x2="19.02"
            y1="6.84"
            y2="23.81"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#9C95F7"></stop>
            <stop offset="1" stopColor="#4B319C"></stop>
          </linearGradient>
        </defs>
      </svg>
    </IconWrap>
  );
};
Wixel.displayName = 'Wixel';

export default Wixel;
